import { CustomerStatus } from "enums";
import React from "react";
import { prettifyCustomerStatus } from "utils/pretty.utils";
import { maskString } from "utils";
import LabelAndValue from "../label-and-value/label-and-value";
import Pill from "../pill/pill";

const DisplayCustomerName = ({ data = {}, maskMobile = false }) => {
  const { firstName, lastName, mobileNumber, status } = data;
  const displayMobile = maskMobile ? maskString(mobileNumber) : mobileNumber;

  return (
    <LabelAndValue label={displayMobile}>
      <div
        style={{
          whiteSpace: "nowrap",
          wordBreak: "keep-all",
          display: "flex",
          alignItems: "center",
        }}
      >
        {`${firstName} ${lastName}`.trim()}{" "}
        {status === CustomerStatus.Deleted && (
          <Pill
            cement
            xsmall
            style={{
              marginLeft: "5px",
              display: "flex",
              alignItems: "center",
            }}
          >
            {prettifyCustomerStatus(status)}
          </Pill>
        )}
      </div>
    </LabelAndValue>
  );
};

export default DisplayCustomerName;
